import { render, staticRenderFns } from "./markdownPreview.vue?vue&type=template&id=37845124&scoped=true"
import script from "./markdownPreview.vue?vue&type=script&lang=js"
export * from "./markdownPreview.vue?vue&type=script&lang=js"
import style0 from "./markdownPreview.vue?vue&type=style&index=0&id=37845124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37845124",
  null
  
)

export default component.exports